import { BaseEntity } from "yt-ng-framework";

export class PodVrstaDokumentaStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    PodVrstaDokumenta:number = null;
    Naziv:string = null;
    Sifra:string = null;
    Aktivan:boolean = null;
    PodvrstaDokumentaGn:string=null;
    OdgovornoLiceID:number = null;
    BrojDecimala: number = 0;

    Deserialize(input:any){
        this.ID=input.ID;
        this.PodVrstaDokumenta=input.PodVrstaDokumenta;
        this.Naziv=input.Naziv;        
        this.Sifra=input.Sifra;
        this.Aktivan = input.Aktivan;
        this.PodvrstaDokumentaGn=input.PodvrstaDokumentaGn;
        this.OdgovornoLiceID=input.OdgovornoLiceID;
        this.BrojDecimala = input.BrojDecimala;
        return this;
    }

    Serialize(input:PodVrstaDokumentaStavkaView){
        return input;
    }
}